<template>
  <CompleteTable
    :sorted-field="sortedField"
    :data="items.data.data"
    :sort-mapping="sortMapping"
    :title="'tasks'"
    :total="items.total"
    :fetch-path="'-'"
    :filter-path="'alerts/fetchTasks'"
    :actions="true"
    @selectedItems="saveSelectedItems"
  >
    <template v-slot="{field}">
      <td
        class="text-end"
      >
        <b-dropdown
          variant="link"
          no-caret
          toggle-class="p-0"
          right
        >
          <template #button-content>
            <i data-feather="more-vertical" />
          </template>
          <div class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block">
            <b-dropdown-item @click="$emit('showAlert', field)">
              <i class="me-50" data-feather="eye" /> View
            </b-dropdown-item>
            <!-- document_* with fallback to the legacy sign_* names, so the Sign
                 link survives against an API deployed before the rename -->
            <b-dropdown-item
              v-if="field.document_file_id || field.sign_file_id"
              :to="{ name: 'cae.view-document', params: { id: field.document_file_id || field.sign_file_id }, query: { host: field.document_host_id || field.sign_host_id, user: field.document_user_id || field.sign_user_id } }"
            >
              <i class="me-50" :data-feather="field.action_type === 'sign' ? 'edit' : 'eye'" /> {{ field.targetable_name || 'OSH documentation' }} — {{ field.action_type === 'sign' ? 'Sign' : 'View document' }}
            </b-dropdown-item>
            <div
              v-if="field.action_type !== 'sign'"
              class="dropdown-divider"
            />
            <b-dropdown-item
              v-if="field.action_type !== 'sign'"
              @click="markAsDone(field)"
            >
              <i class="me-50" :data-feather="field.done ? 'x' : 'check'" /> {{ field.done ? 'Mark as not done' : 'Mark as done' }}
            </b-dropdown-item
            >
          </div>
        </b-dropdown>
        <a
          href=""
          class="btn btn-icon btn-flat-secondary d-block d-sm-none"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasMenu"
          aria-controls="offcanvasBottom"
        ><i data-feather="more-vertical" /></a>
      </td>
    </template>
    <template #customfilters>
      <div
        v-if="hasAdminPermission('view publications')"
        class="mb-1"
      >
        <label
          for="nameseniorcall"
          class="form-label"
        >Researcher</label>
        <v-select
          v-model="filters.researcher"
          label="name"
          :options="users"
          :get-option-key="option => option.id"
          @search="onSearch({ name: $event }, 'users/fetchFakeUsers')"
          @input="saveFilter({ customLabel: true, name: `Researcher: ${$event.name}`, value: $event }, 'researcher')"
        />
        <hr>
      </div>
      <div class="mb-1">
        <label
          for="areaseniorcall"
          class="form-label"
        >Title</label>
        <input
          v-model="filters['title']"
          type="text"
          class="form-control"
          @change="saveFilter({ customLabel: true, name: `Title: ${$event.target.value}`, value: `${$event.target.value}` }, 'title')"
        >
      </div>
      <div class="mb-1">
        <label
          for="areaseniorcall"
          class="form-label"
        >Send by</label>
        <v-select
          v-model="filters.send_by"
          label="name"
          :options="users"
          :get-option-key="option => option.id"
          @search="onSearch({ name: $event }, 'users/fetchFakeUsers')"
          @input="saveFilter({ customLabel: true, name: `Send by: ${$event.name}`, value: $event }, 'send_by')"
        />
      </div>
      <div class="mb-1">
        <label
          for="nameseniorcall"
          class="form-label"
        >Alert date</label>
        <br>
        <date-picker
          v-model="filters['alert_date']"
          format="D MMM Y"
          value-type="format"
          class="w-100"
          @change="saveFilter({ customLabel: true, name: `Alert date: ${$event}`, value: $event }, 'alert_date')"
        />
      </div>
      <div class="mb-1">
        <label
          for=""
          class="form-label"
        >With document</label>
        <v-select
          v-model="filters['with_documents']"
          label="name"
          :options="[
            { name: 'Yes', value: true },
            { name: 'No', value: false },
            { name: 'All', value: null },
          ]"
          :get-option-key="option => option"
          @input="saveFilter({ customLabel: true, name: `With documents: ${$event.name}`, value: $event }, 'with_documents')"
        />
      </div>
      <div class="mb-1">
        <label
          for=""
          class="form-label"
        >Read</label>
        <v-select
          v-model="filters['read']"
          label="name"
          :options="[
            { name: 'Yes', value: true },
            { name: 'No', value: false },
            { name: 'All', value: null },
          ]"
          :get-option-key="option => option"
          @input="saveFilter({ customLabel: true, name: `Read: ${$event.name}`, value: $event }, 'read')"
        />
      </div>
      <div class="mb-1">
        <label
          for=""
          class="form-label"
        >Done</label>
        <v-select
          v-model="filters['done']"
          label="name"
          :options="[
            { name: 'Yes', value: true },
            { name: 'No', value: false },
            { name: 'All', value: null },
          ]"
          :get-option-key="option => option"
          @input="saveFilter({ customLabel: true, name: `Done: ${$event.name}`, value: $event }, 'done')"
        />
      </div>
    </template>
    <template #info-sheet-item>
      <div class="offcanvas-body offcanvas-body--view">

        <h4 class="mb-2">
          <strong class="text-success">{{ selectedItems.length }}</strong> selected registers
        </h4>

        <ul
          id="basic-list-group"
          class="list-group"
        >
          <li class="list-group-item draggable">
            <div class="d-flex">
              <div class="more-info">
                <div class="form-check">
                  <input
                    id="tableAction1"
                    v-model="actions.archive"
                    type="checkbox"
                    class="form-check-input"
                  >
                  <label
                    class="form-check-label"
                    for="tableAction1"
                  >Archive</label>
                </div>
              </div>
            </div>
            <div class="more-info">
              <div class="form-check">
                <input
                  id="tableAction2"
                  v-model="actions.mark_done"
                  type="checkbox"
                  class="form-check-input"
                >
                <label
                  class="form-check-label"
                  for="tableAction2"
                >Mark as done</label>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="offcanvas-footer mt-auto">
        <a
          href="#"
          title="apply actions"
          class="btn btn-primary mb-1 d-grid w-100"
          @click="applyActions"
        >Apply actions</a>
      </div>
    </template>
  </CompleteTable>
</template>

<script>
import { mapGetters } from 'vuex'
import CompleteTable from '@/views/back/partials/components/CompleteTable.vue'
import Vue from 'vue'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      actions: {},
      userId: this.$route.params.id,
      loading: false,
      selectedItems: [],
      clicked: false,
      sortedField: 'Title',
      defaultFields: [
        {
          name: 'Researcher',
          checked: true,
          order: 1,
          only_admin: true,
        },
        {
          name: 'Title',
          checked: true,
          order: 2,
        },
        {
          name: 'Send by',
          checked: true,
          order: 3,
        },
        {
          name: 'Task begin date',
          checked: true,
          order: 4,
        },
        {
          name: 'Task end date',
          checked: true,
          order: 5,
        },
        {
          name: 'Read',
          checked: true,
          order: 6,
        },
        {
          name: 'Done',
          checked: true,
          order: 7,
        },
        {
          name: 'Status',
          checked: true,
          order: 8,
        },
      ],
      sortMapping: {
        Researcher: 'researcher.name',
        Title: 'title',
        'Send by': 'send_by',
        'Task begin date': 'alert_date_formatted',
        'Task end date': 'end_date_formatted',
        // No Files column: a bare attachment count is not actionable, and the files
        // themselves are listed with their links in the View sheet (alerts/Index.vue).
        Read: 'read',
        Done: 'done',
        // Why the task is still open: a document sent back by ICREA reads as
        // rejected, not as one that was never touched. Pre-rendered as a badge by
        // TaskResource, like the booleans this table already builds.
        Status: 'status_badge',
      },
    }
  },
  computed: {
    ...mapGetters({
      items: 'alerts/tasks',
      filters: 'filters/filters',
      users: 'users/fakeUsers',
      loggedUser: 'auth/admin',
      fields: 'modals/tableSettingsFields',
    }),
  },
  async mounted() {
    await this.$store.dispatch('alerts/fetchTasks', this.filters)
    await this.$store.dispatch('modals/fetchUserFields', 'tasks')
    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'tasks',
      })
    }
    feather.replace({
      width: 14,
      height: 14,
    })
  },
  methods: {
    saveFilter(value, field) {
      this.filters[field] = value
      this.$store.dispatch('filters/saveFilters', {
        value,
        field,
      })
    },
    async onSearch(search, store) {
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
    applyActions() {
      if (this.selectedItems.length > 0) {
        Vue.swal({
          title: 'Do you want to apply the selected actions?',
          html: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Yes',
        }).then(async result => {
          if (result.isConfirmed) {
            // forEach does not await, so the refetches below used to run before the
            // dispatches had finished and showed stale data.
            if (this.actions.mark_done) {
              await Promise.all(this.selectedItems.map(e => this.$store.dispatch('alerts/mark', e.alert_id)))
            }

            if (this.actions.archive) {
              await Promise.all(this.selectedItems.map(e => this.$store.dispatch('alerts/archive', e.alert_id)))
            }

            this.loading = true
            await this.$store.dispatch('alerts/fetchTasks', this.filters)
            // Marking done/archiving changes what the tab badges count, so refresh them
            // with the list or the headers keep showing the previous numbers.
            await this.$store.dispatch('alerts/fetchAlertData')
            this.loading = false

            feather.replace({
              width: 14,
              height: 14,
            })
            this.$store.dispatch('modals/toggleInfoItemSheet', false)
            this.selectedItems = []
          }
        })
      } else {
        this.$toastr.error('', 'Please, select any task before applying')
      }
    },
    selectAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.items
      } else {
        this.selectedItems = []
      }
    },
    select(click, item) {
      if (click) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(this.selectedItems.findIndex(x => x.id === item.id), 1)
      }
    },
    saveSelectedItems(items) {
      this.selectedItems = items
    },
    async markAsDone(field) {
      try {
        // field may contain alert_id or id depending on source
        const id = field.alert_id || field.id
        if (!id) return
        await this.$store.dispatch('alerts/mark', id)
        // Refresh tasks list and the tab badges it feeds
        await this.$store.dispatch('alerts/fetchTasks', this.filters)
        await this.$store.dispatch('alerts/fetchAlertData')
        feather.replace({ width: 14, height: 14 })
        Vue.$toast && Vue.$toast('Marked as done')
      } catch (e) {
        // fallback to swal if available
        if (Vue.swal) Vue.swal('Error', 'Could not mark as done', 'error')
        console.error(e)
      }
    },
  },
}
</script>
